import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSetupAuditTrailSections } from '@api';

export const getCoreSetupAuditTrailSectionsSlice = createGetAsyncSlice({
	name: 'CoreSetupAuditTrailSections',
	receive: true,
	request: false,
	requestHandler: getSetupAuditTrailSections,
	retainDataOnRequest: true
});
